module.exports = __webpack_public_path__ + "img/1f622.54fcaf0.svg";